import { render, staticRenderFns } from "./modal-incidente-otros.vue?vue&type=template&id=ea53b950"
import script from "./modal-incidente-otros.vue?vue&type=script&lang=js"
export * from "./modal-incidente-otros.vue?vue&type=script&lang=js"
import style0 from "./modal-incidente-otros.vue?vue&type=style&index=0&id=ea53b950&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports